import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { RaiseSupportTicketComponent } from "src/app/shared/components/raise-support-ticket/raise-support-ticket.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";

@Component({
  selector: "sm-support-ticket",
  templateUrl: "./support-ticket.component.html",
  styleUrls: ["./support-ticket.component.scss"],
})
export class SupportTicketComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  supportTicketList: any = [];
  loader: boolean = false;
  public page: number = 1;
  datalength!: number;
  constructor(
    private _navservice: NavigationService,
    private route: ActivatedRoute,
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private router: Router,
    private dialog: MatDialog

  ) {
    this._navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_SPECIFIC_SUPPORT_TICKETS
      ) {
        this.supportTicketList = [];
        if (resdata.result) {
          this.datalength = resdata.result ? resdata.result[0].total_results : 0;
          this.supportTicketList = resdata.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
    });
  }

  ngOnInit(): void {
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.apiservice.getEntitySpecificSupportTickets(data.entityHash,this.page.toString());
    });
  }
  openDetails(ticket: any) {
    sessionStorage.setItem("selectedTicket", JSON.stringify(ticket));
    this.router.navigate(["support-ticket-details"], {
      relativeTo: this.route,
      queryParams: { ticketHash: ticket.hash_id },
      queryParamsHandling: "merge",
    });
  }
  addNewQuery() {
    let dialogref = this.dialog.open(RaiseSupportTicketComponent,{
      width: '600px',
      data:{
        title: 'Raise Support Query',
        ref: this.dialog
      }
    })

    dialogref.afterClosed().subscribe(res =>{
      if(res){
          this.ngOnInit()
      }
    })
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.apiservice.getEntitySpecificSupportTickets(data.entityHash, this.page.toString());
    });
  }

  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"",
      title: 'Business profile'
    }})
    }
  
    opencontact(){
      this.router.navigate(['/contact-us']);
    }
  
    openLink(url: string): void {
      window.open(url, '_blank');
    }
}
